import { render, staticRenderFns } from "./ThemesSelector.vue?vue&type=template&id=16245fdd&"
import script from "./ThemesSelector.vue?vue&type=script&lang=js&"
export * from "./ThemesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports